import { render, staticRenderFns } from "./ControlFiles.vue?vue&type=template&id=4013d7cc&"
import script from "./ControlFiles.vue?vue&type=script&lang=js&"
export * from "./ControlFiles.vue?vue&type=script&lang=js&"
import style0 from "./ControlFiles.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports